import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./CourseSummary.module.scss";
import {FontIcon, Icon} from "../../common/FontIcon";
import {useCourseSummaryLogic} from "./CourseSummary.logic";
import {ICourseOverviewLessonFeatures} from "../../../config/course-overview";
import {SafeText} from "../SafeText";

export interface ILessonFeatureProps {
  hasInteractiveNotation: boolean,
  hasVideo: boolean,
}

export interface ICourseSummaryProps {
  summary: string,
  lessonFeatures?: ICourseOverviewLessonFeatures,
  organizationMethod: string,
}

export const CourseSummary: VoidFunctionComponent<ICourseSummaryProps> = ({
  summary,
  lessonFeatures,
  organizationMethod,
}) => {
  const { lessonFeaturesLabel, courseOrgIcon } = useCourseSummaryLogic({lessonFeatures, organizationMethod});

  return (
    <div className={s.courseSummary}>
      <h3>Summary</h3>
      <p>
        <SafeText text={summary}></SafeText>
      </p>
      <dl className={s.courseMetadata}>
        <div className={s.courseMetadataItem}>
          <FontIcon icon={lessonFeatures?.hasVideo ? "icon-type-video-and-notation" : "icon-type-notation"}></FontIcon>
          <dt className={s.label}>Lesson types</dt>
          <dd className={s.value}>
            {lessonFeaturesLabel}
          </dd>
        </div>
        <div className={s.courseMetadataItem}>
          <FontIcon icon={courseOrgIcon as Icon}></FontIcon>
          <dt className={s.label}>Course organization</dt>
          <dd className={s.value}>{organizationMethod}</dd>
        </div>
      </dl>
    </div>
  );
}

